import { fadeInOut } from '@dgx-pr-spa/shared/util';
import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  Renderer2,
  OnChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { Image } from '@dgx-pr-spa/shared/util';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  animations: [fadeInOut],
})
export class CarouselComponent implements OnChanges {
  /**
   * Emits a checked event back to the parent component
   */
  @Output() clicked: EventEmitter<void> = new EventEmitter();

  /**
   * Accepts an array of images
   */
  @Input() slides: Image[];

  /**
   * Get a refetence to thumbnails element
   */
  @ViewChild('thumbnails') thumbnails: ElementRef;

  /**
   * Property to determine which image is currently in view - used to seperate the on hover thumbnail and click logic
   */
  slideInView = 0;

  /**
   * Property to determine which slide is currently active - used to seperate the on hover thumbnail and click logic
   */
  activeSlide = 0;

  /**
   * Set the number of pixels to shift the thumbnails
   */
  thumbnailContainerWidth = 300;

  constructor(public renderer: Renderer2) {}

  /**
   * On Changes triggered when new replacement is loaded
   */
  ngOnChanges() {
    this.resetUI();
    this.handleEmptyImages();
  }

  /**
   * Add empty image into array if no slides exist
   */
  handleEmptyImages() {
    if (this.slides?.length < 1) {
      this.slides = [...this.slides];
      this.slides.push({
        text: 'Image not available wording on grey background',
        url: './assets/images/img-unavailable-large-x2.png',
      });
    }
  }

  /**
   * Reset the Carousel UI
   */
  resetUI() {
    this.slideInView = 0;
    this.activeSlide = 0;

    if (this.thumbnails?.nativeElement) {
      this.renderer.setStyle(this.thumbnails.nativeElement, 'left', `0px`);
    }
  }

  /**
   * Handle the click forward and swiperight and conditionally set the thunbnail position
   */
  onNextClick() {
    if (this.activeSlide === this.slides.length - 1) {
      return;
    }

    this.shiftThumbnails(-this.thumbnailContainerWidth);
    this.activeSlide++;
    this.slideInView = this.activeSlide;
  }

  /**
   * Handle the click back and swipeleft and conditionally set the thunbnail position
   */
  onPreviousClick() {
    if (this.activeSlide === 0) {
      return;
    }
    this.activeSlide--;
    this.slideInView = this.activeSlide;
    this.shiftThumbnails(this.thumbnailContainerWidth);
  }

  /**
   * Set the current slide to the thumbnail clicked via the index value
   */
  onThumbnailClick(i: number) {
    this.clicked.emit();
    this.activeSlide = i;
  }

  /**
   * Set the left position of the thumbnail group
   */
  shiftThumbnails(pixels: number) {
    if ((this.activeSlide + 1) % 3 === 0) {
      const currentPosition = this.thumbnails.nativeElement.offsetLeft;
      const newPosition = currentPosition + pixels;

      this.renderer.setStyle(
        this.thumbnails.nativeElement,
        'left',
        `${newPosition}px`
      );
    }
  }

  /**
   * Use current thumbnail index to change the slideInView
   */
  onMouseOver(i: number) {
    this.slideInView = i;
  }

  /**
   * Revert back to activeSlide
   */
  onMouseOut() {
    this.slideInView = this.activeSlide;
  }
}
